// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import Antd from 'ant-design-vue';
import 'es6-promise/auto'
import 'ant-design-vue/dist/antd.css';
import Fragment from 'vue-fragment'
import DefaultLayout from './views/Default'
import NoSidebarLayout from './views/NoSidebar'
import axios from 'axios'
import qs from 'qs'
import App from './App'
import router from './router'
import store from './store'

Vue.component('default-layout',DefaultLayout)
Vue.component('no-sidebar-layout',NoSidebarLayout)
Vue.use(Antd)
Vue.use(Vuex)
Vue.use(Fragment.Plugin)
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
router.beforeEach((to, from, next) => {
  let getFlag = localStorage.getItem("Flag")
  if(getFlag === "isLogin")
  {
    store.state.isLogin = true
    next()
    if(!to.meta.isLogin)
    {
      next()
    }
  }
  else
  {
    if(to.meta.isLogin)
    {
      next({
        path:"/"
      })
    }
    else
    {
      next()
    }
  }
})
router.afterEach( router =>{
  window.scroll(0,0);
})


// WEBPACK FOOTER //
// ./src/main.js